export const isValidEmail = (input) => input.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);